import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "../GlobalContext/GlobalContext";
import { logOutApiCall } from "../Utils/Exception";

const SessionTimeout = () => {
  const { setIsLoginPopup } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  let idleTimer;

  useEffect(() => {
    const handleActivity = async () => {
      if (idleTimer) clearTimeout(idleTimer);
      
      // Wait for handleLogout to complete
      await handleLogout();
    
      // After handleLogout finishes, set new session_expiry
      localStorage.setItem("session_expiry", Date.now() + 30 * 60 * 1000); // 3 mins
      idleTimer = setTimeout(handleLogout, 30 * 60 * 1000); // Reset timer
    };
    

    const handleLogout = async () => {
      const storedExpiry = parseInt(localStorage.getItem("session_expiry") || "0", 10);
      const now = Date.now();
      // console.log(`Checking expiry: storedExpiry=${storedExpiry}, now=${now}`);
      
      if (now >= storedExpiry) {
        // Broadcast logout to all tabs
        localStorage.setItem("session_expired", Date.now().toString());
        if (!['/login', '/forgot-password', '/mfa'].includes(location.pathname)) {
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
          const emp_id = storedUserInfo?.emp_id;
          logOutApiCall(emp_id, 'inactivity timeout' );
          setTimeout(() => {
            localStorage.removeItem("userRole");
            localStorage.removeItem("_userInfo_");
            setIsLoginPopup(true);
            navigate('/login');
            window.location.reload();
          }, 500);
        }
      } else {
        // console.log("Session not expired yet.");
      }
      
      return Promise.resolve(); // Ensures await works smoothly
    };
    

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log("Tab became active. Checking session expiry...");
        const userRole = localStorage.getItem("userRole");
        const userInfo = localStorage.getItem("_userInfo_");
        if (!['/login', '/forgot-password', '/mfa'].includes(location.pathname)) {
          if (!userRole || !userInfo) {
            // Broadcast logout to all tabs
            localStorage.setItem("session_expired", Date.now().toString());

            navigate('/login');
            window.location.reload();
          } else {
            console.log("clear local storage:",location.pathname);
          }
        }else{
          console.log("location.pathname:",location.pathname);
        }
      }
    };

    // Event listeners
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("click", handleActivity);
    window.addEventListener("scroll", handleActivity);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    idleTimer = setTimeout(handleLogout, 30 * 60 * 1000); // Init

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("scroll", handleActivity);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (idleTimer) clearTimeout(idleTimer);
    };
  }, [navigate, setIsLoginPopup, location.pathname]);

  return null;
};

export default SessionTimeout;
